import * as DestinationAlertsService from 'api/destinationAlerts'
import { API_CALL } from 'actions/actionConstants'

import {
  ADD_USER_DESTINATION_ALERT,
  ADD_USER_POPULAR_REGION_ALERT,
  DELETE_USER_DESTINATION_ALERT,
  DELETE_USER_POPULAR_REGION_ALERT,
  FETCH_DESTINATION_OFFERS,
  FETCH_FEATURED_DESTINATIONS,
  FETCH_HOTEL_POPULAR_HOLIDAY_TYPES,
  FETCH_POPULAR_DESTINATIONS,
  FETCH_POPULAR_REGIONS,
  FETCH_TRENDING_DESTINATIONS,
  FETCH_HOTEL_TRENDING_DESTINATIONS,
  FETCH_USER_DESTINATION_ALERTS,
  FETCH_USER_POPULAR_REGION_ALERTS,
} from 'actions/apiActionConstants'
import { getGoogleGeocode } from 'api/googleMaps'
import { getPopularDestinations } from 'api/search'

export function fetchUserDestinationAlerts() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: FETCH_USER_DESTINATION_ALERTS,
      request: () => DestinationAlertsService.getDestinationAlertList(state.geo.currentRegionCode),
    })
  }
}

export function getPopularRegionAlertList() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: FETCH_USER_POPULAR_REGION_ALERTS,
      request: () => DestinationAlertsService.getPopularRegionAlertList(state.geo.currentRegionCode),
    })
  }
}

export function addPopularRegionAlert(tag) {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: ADD_USER_POPULAR_REGION_ALERT,
      request: () => DestinationAlertsService.addRegionAlert(tag)
        .then((newAlert) =>
          DestinationAlertsService.getPopularRegionAlertList(state.geo.currentRegionCode)
            .then(alertList => alertList.find(alert => alert.tag === newAlert.tag),
            ),
        ),
    })
  }
}

export function addDestinationAlert(placeId: string) {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: ADD_USER_DESTINATION_ALERT,
      request: async() => {
        const geoDetails = await getGoogleGeocode({ placeId })
        await DestinationAlertsService.addDestinationAlert(geoDetails)
        const allAlerts = await DestinationAlertsService.getDestinationAlertList(state.geo.currentRegionCode)
        return allAlerts.find(alert => alert.placeId === placeId)
      },
    })
  }
}

export function deleteDestinationAlert(alertId: string) {
  return {
    type: API_CALL,
    api: DELETE_USER_DESTINATION_ALERT,
    request: () => DestinationAlertsService.deleteDestinationAlerts(alertId),
    alertId,
  }
}

export function fetchDestinationOffers(placeId: string) {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: FETCH_DESTINATION_OFFERS,
      request: () => DestinationAlertsService.getDestinationOffers(placeId, state.geo.currentRegionCode),
    })
  }
}

export function deletePopularRegionAlert(tag) {
  return {
    type: API_CALL,
    api: DELETE_USER_POPULAR_REGION_ALERT,
    request: () => DestinationAlertsService.deletePopularRegionAlert(tag),
    tag,
  }
}

export function fetchFeaturedDestinations() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    if (
      !state.destination?.areFeaturedDestinationsLoaded &&
      !state.destination?.fetchingFeaturedDestinations
    ) {
      dispatch({
        type: API_CALL,
        api: FETCH_FEATURED_DESTINATIONS,
        request: () => DestinationAlertsService.getFeaturedDestinations(state.geo.currentRegionCode),
      })
    }
  }
}

export function fetchPopularRegions() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: FETCH_POPULAR_REGIONS,
      request: () => DestinationAlertsService.getPopularRegions(state.geo.currentRegionCode),
    })
  }
}

export function fetchPopularDestinations(destinationsType: 'domestic' | 'international') {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const { popularDestinations } = state.destination

    if (!popularDestinations[destinationsType].destinations && !popularDestinations[destinationsType].fetching) {
      dispatch({
        type: API_CALL,
        api: FETCH_POPULAR_DESTINATIONS,
        request: () => getPopularDestinations(destinationsType, state.geo.currentRegionCode),
        destinationsType,
      })
    }
  }
}

export function fetchTrendingDestinations() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    if (state.destination.trendingDestinations.length === 0 && !state.destination.fetchingTrendingDestinations) {
      dispatch({
        type: API_CALL,
        api: FETCH_TRENDING_DESTINATIONS,
        request: () => DestinationAlertsService.getTrendingDestinations(state.geo.currentRegionCode),
      })
    }
  }
}

export function fetchHotelTrendingDestinations(limit: number, sortBy: App.HotelTrendingSortByOptions, exclude: string[], percentile: number, key: string) {
  return (dispatch, getState) => {
    const state = getState() as App.State

    const fetching = state.destination.fetchingHotelTrendingDestinations[key] ?? false

    const trending = state.destination.hotelTrendingDestinations[key] ?? []

    if (trending.length === 0 && !fetching) {
      dispatch({
        type: API_CALL,
        api: FETCH_HOTEL_TRENDING_DESTINATIONS,
        request: () => DestinationAlertsService.getHotelTrendingDestinations(state.geo.currentRegionCode, limit, sortBy, exclude, percentile),
        key,
      })
    }
  }
}

export function fetchHotelPopularHolidayTypes() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    if (state.destination.hotelPopularHolidayTypes.length === 0 && !state.destination.fetchingHotelPopularHolidayTypes) {
      dispatch({
        type: API_CALL,
        api: FETCH_HOTEL_POPULAR_HOLIDAY_TYPES,
        request: () => DestinationAlertsService.getHotelPopularHolidayTypes(state.geo.currentRegionCode),
      })
    }
  }
}
